export const CommerceProviderError = {
  tenants:
    'Failed to fetch commerce providers. Please refresh the page. If the error persists - contact support.',
  stores:
    'Failed to fetch the list of stores. Please refresh the page. If the error persists - contact support.',
};
